<template>
  <div class="ts-sorter" @click="handleClick">
    <div class="name">
      <slot></slot>
    </div>
    <div v-if="sort" class="button">
      <div class="chevron" :class="[sort]">
        <ChevronDown />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ts-sorter {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 18px;

  .name {
    font-family: Roboto;
    font-size: 10px;
    line-height: 14px;
    color: #9aa5b7;
  }

  .button {
    margin-left: 4px;

    .chevron {
      transition: transform 0.3s;

      &.asc {
        transform: rotate(180deg);
      }
    }
  }
}
</style>

<script>
import ChevronDown from '../../assets/chevron-down.svg';

export default {
  name: 'TsSorter',
  components: {
    ChevronDown
  },
  props: {
    sort: {
      type: String,
      default: null
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
